import ParameterErrors from '../errors/ParameterErrors';
import Validation from '../validation/Validation';
import DynamicImageFitCriteria from './DynamicImageFitCriteria';
import DynamicImageEntry from './DynamicImageEntry';
const{throwNotProvided, throwNotOfType}=ParameterErrors;
export default class DynamicImage {
	constructor(props){
		const {entries}=props;
		this._entriesIncreasing = entries;
		this._entriesIncreasing.sort(function(a, b) {
			return a.width - b.width;
		});
		this.getBestEntryToFit= this.getBestEntryToFit.bind(this);
		this.getBestEntryToFitWidth= this.getBestEntryToFitWidth.bind(this);
		this.getBestEntryToFitHeight= this.getBestEntryToFitHeight.bind(this);
	}
	get entries(){
		return this._entriesIncreasing;
	}
	getLargestEntry (){
		return this._entriesIncreasing[this._entriesIncreasing.length-1];
	}
	getBestEntryToFit(params){
		const {fitCriteria}=params;
		if(!fitCriteria)throwNotProvided('fitCriteria');
		if(fitCriteria.fitWidth){
			return this.getBestEntryToFitWidth(params.width);
		}
		return this.getBestEntryToFitHeight(params.height);
	}
	getBestEntryToFitWidth(width){//Can improve how it picks images later. 
		var i=0; 
		while(i<this._entriesIncreasing.length){
			const entry = this._entriesIncreasing[i++];
			if(entry.width>=width){
				return entry;
			}
		}
		return this._entriesIncreasing[i-1];
	}
	getBestEntryToFitHeight(height){
		var i=0; 
		while(i<this._entriesIncreasing.length){
			const entry = this._entriesIncreasing[i++];
			if(entry.height>=height){
				return entry;
			}
		}
		return this._entriesIncreasing[i-1];
	}
	static fromJSON(jObject){
		return new DynamicImage({
			entries:jObject.entries.map(entry=>new DynamicImageEntry(entry))
		});
	}
}